exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".entity-card {\n  display: grid;\n  margin: 0 16px 16px;\n  background-color: #fff;\n  border: 1px solid #a7a8aa;\n  min-height: 132px;\n  width: 100%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js?{"javascriptEnabled":true}!./src/components/EntityCard/EntityCard.less
// module id = 879
// module chunks = 0